exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cpd-ext-card[data-v-7baaa098]{overflow:hidden}.cpd-ext-card[data-v-7baaa098]  .v-toolbar__title{font-size:18px;font-weight:500}.cpd-ext-table[data-v-7baaa098]  .v-data-table__wrapper{overflow-x:auto}.cpd-ext-table[data-v-7baaa098]  table{min-width:980px}.cpd-ext-table[data-v-7baaa098]  .v-data-table-header th{font-size:11px;font-weight:600;color:#263238!important;vertical-align:middle;line-height:1.25}.cpd-ext-table[data-v-7baaa098]  tbody td{font-size:12px;line-height:1.35;vertical-align:middle}", ""]);

// exports
